"use client";

import Image, { type ImageProps } from "next/legacy/image";
import { useEffect, useState, type ReactNode } from "react";

export interface SafeLegacyImageProps extends ImageProps {
  readonly fallback?: ReactNode;
}

/**
 * next/legacy/image wrapper that hides broken URLs instead of showing the browser broken-icon.
 */
export function SafeLegacyImage({
  src,
  fallback = null,
  onError,
  ...props
}: SafeLegacyImageProps) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) {
    return <>{fallback}</>;
  }

  return (
    <Image
      src={src}
      onError={(event) => {
        setFailed(true);
        onError?.(event);
      }}
      {...props}
    />
  );
}
